import "./index.css";

import { createApp } from "vue";
import LandingApp from "./public/LandingApp.vue";

const el = document.getElementById("landing-application");

if (el) {
    const state = window._landing_initial || { blocks: [], chrome: {}, seo: {}, theme: {} };
    createApp(LandingApp, { state }).mount(el);
}
